import {Link, useParams} from 'react-router-dom'
import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {useAuth} from '../../../modules/auth'
import Swal from 'sweetalert2'
import {
  commencerDemandeDemontage,
  getDemandeDemontageInfo,
  postPiecesDemontees,
} from '../../../../components/requests'
import {LoadingData} from '../../../../components/LoadingData'
import {DemandeDemontageDetailsHeader} from '../components/DemandeDemontageDetailsHeader'
import {RefusDemontageRealisationModal} from '../RefusDemontageRealisationModal'
import ClientDemandeMessage from '../../suggestion/Components/ClientDemandeMessage'

const DemandeDemontageRealisation = () => {
  const params = useParams()
  const demandeDemontageId: any = params?.demandeDemontageId
  const vehiculeId: any = params?.vehiculeId
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(true)
  const [loadingCommencer, setLoadingCommencer] = useState(false)
  const [loadingDemonter, setLoadingDemonter] = useState(false)
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [checkedPieces, setCheckedPieces] = useState<number[]>([])
  const [openRefusDemontageModal, setOpenRefusDemontageModal] = useState<boolean>(false)
  const [data, setData] = useState<any>([])

  useEffect(() => {
    getInfoDemandeDemontageData()
  }, [])

  const getInfoDemandeDemontageData = () => {
    getDemandeDemontageInfo(demandeDemontageId, vehiculeId).then((demandeDemontageRequest) => {
      if (demandeDemontageRequest?.status === 200) {
        if (demandeDemontageRequest?.data !== undefined) {
          setData(demandeDemontageRequest?.data)
          setLoading(false)
        }
      }
    })
  }

  const commencerRealisation = (demandeDemontageId) => {
    Swal.fire({
      title: 'Confirmation',
      text: 'Commencer la réalisation de la demande de démontage',
      icon: 'info',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoadingCommencer(true)
        commencerDemandeDemontage(demandeDemontageId, currentUser?.id).then((response) => {
          if (response?.status === 200) {
            const updatedData = data.map((item) => ({
              ...item,
              statut: response?.data?.statut,
              dateDebutRealisation: response?.data?.dateDebutRealisation,
              realisePar: response?.data?.realisePar,
            }))

            setData(updatedData)
            toast.success('Demande de démontage en cours...')
            setLoadingCommencer(false)
          }
        })
      }
    })
  }

  const handleDemonterPiecesSubmit = () => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la soumission',
      icon: 'info',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoadingDemonter(true)

        // Récupère les pièces non encore réalisées
        const nonRealisedIds = data[0]?.demandeTypePiece
          ?.filter((item) => !item.realise && item.refus === null)
          ?.map((item) => item.id)

        const toSubmitIds = checkedPieces.filter((id) => nonRealisedIds.includes(id))
        postPiecesDemontees(demandeDemontageId, toSubmitIds.join(',')).then((res) => {
          if (res?.status === 200 && res.data) {
            getDemandeDemontageInfo(demandeDemontageId, vehiculeId).then((updatedData) => {
              if (updatedData?.status === 200 && updatedData.data !== undefined) {
                setData(updatedData.data)
                setLoadingDemonter(false)
                const stillNotRealised =
                  updatedData.data[0]?.demandeTypePiece
                    ?.filter((item) => !item.realise && item.refus === null)
                    ?.map((item) => item.id) || []
                setCheckedPieces(stillNotRealised.filter((id) => checkedPieces.includes(id)))
              }
            })
            toast.success('Démontage de pièce(s) avec succès')
          } else {
            setLoadingDemonter(false)
          }
        })
      }
    })
  }

  const handleSelectAll = () => {
    const notRealisedIds = data[0]?.demandeTypePiece
      .filter((item) => !item.realise && item.refus === null)
      .map((item) => item.id)

    if (isAllSelected) {
      // Décocher tous les non réalisés
      setCheckedPieces([])
    } else {
      // Sélectionner tous les non réalisés
      setCheckedPieces(notRealisedIds)
    }

    setIsAllSelected(!isAllSelected)
  }

  useEffect(() => {
    const notRealisedIds = data[0]?.demandeTypePiece
      ?.filter((item) => !item.realise && item.refus === null)
      ?.map((item) => item.id)

    const allSelected =
      notRealisedIds?.length > 0 && notRealisedIds.every((id) => checkedPieces.includes(id))

    setIsAllSelected(allSelected)
  }, [checkedPieces, data])

  const addPiece = (checked: boolean, idPiece: number) => {
    setCheckedPieces((prevArray) => {
      if (checked) {
        // Ajouter seulement si pas déjà présent
        return prevArray.includes(idPiece) ? prevArray : [...prevArray, idPiece]
      } else {
        // Supprimer si décoché
        return prevArray.filter((checkedPiece) => checkedPiece !== idPiece)
      }
    })
  }

  const showRefusDemontageModal = () => {
    setOpenRefusDemontageModal(true)
  }

  const toggleShowRefusDemontageModal = (val: boolean) => {
    setOpenRefusDemontageModal(val)
  }

  return (
    <>
      {loading ? (
        <LoadingData />
      ) : (
        <>
          <DemandeDemontageDetailsHeader
            demontageData={{demandeDemontage: data[0], typePieces: data[0]?.demandeTypePiece}}
            showTypePieces={false}
            loading={false}
          />
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header border-0 d-flex align-items-center justify-content-between'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Réalisation du démontage</h3>
              </div>
              <Link
                to={`/demande-demontage/liste`}
                state={{}}
                data-tooltip-id='tooltip'
                data-tooltip-content='Revenir en arrière'
                data-tooltip-place='right'
              >
                <img src='/media/svg/custom/prev-arrow.svg' width={40} />
              </Link>
            </div>
            <div
              className='card-body border-top'
              style={{paddingTop: 'unset', paddingBottom: 'unset'}}
            >
              {/* begin::Table container */}
              <div className='table-responsive'>
                {/* begin::Table */}
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='w-40px'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          style={{
                            backgroundColor: data[0]?.statut?.code === 'ANNULE' ? 'red' : '',
                          }}
                          checked={
                            isAllSelected ||
                            data[0]?.statut?.code === 'DEMONTEE' ||
                            data[0]?.statut?.code === 'ANNULE'
                          }
                          disabled={
                            data[0]?.statut?.code === 'DEMONTEE' ||
                            data[0]?.statut?.code === 'VALIDE' ||
                            data[0]?.statut?.code === 'ANNULE'
                          }
                          onChange={handleSelectAll}
                          aria-label='Sélectionner tous les éléments'
                        />
                      </th>
                      <th className='min-w-150px'>Type pièces</th>
                    </tr>
                  </thead>
                  {/* end::Table head */}

                  {/* begin::Table body */}
                  <tbody>
                    {data[0]?.demandeTypePiece?.map((piece) => (
                      <tr key={piece?.id}>
                        <td>
                          <input
                            type='checkbox'
                            className='form-check-input'
                            style={{
                              backgroundColor: piece.refus !== null ? 'red' : '',
                            }}
                            onChange={(e) => addPiece(e.target.checked, piece.id)}
                            checked={
                              !['VALIDE'].includes(data[0]?.statut?.code) &&
                              (piece.realise ||
                                piece.refus !== null ||
                                checkedPieces.includes(piece.id))
                            }
                            disabled={
                              piece.realise ||
                              piece.refus !== null ||
                              ['VALIDE', 'ANNULE'].includes(data[0]?.statut?.code)
                            }
                            aria-label={`Sélectionner ${piece.typePiece ? piece.typePiece.nom : piece.typePieceHn}`}
                          />
                        </td>
                        <td>
                          <p
                            className={`text-dark fw-bold ${
                              piece.refus !== null ? 'text-hover-danger' : 'text-hover-primary'
                            } d-block fs-6 mb-0`}
                          >
                            {piece.typePiece ? piece.typePiece.nom : piece.typePieceHn}
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {/* end::Table body */}
                </table>
                {/* end::Table */}
              </div>
              {/* end::Table container */}
            </div>
            {(data[0]?.statut?.code === 'VALIDE' || data[0]?.statut?.code === 'EN COURS') && (
              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                {data[0]?.statut?.code === 'VALIDE' && (
                  <button
                    type='button'
                    className='btn btn-primary me-3'
                    onClick={() => commencerRealisation(demandeDemontageId)}
                    disabled={data[0]?.statut?.code !== 'VALIDE'}
                  >
                    {!loadingCommencer && data[0]?.statut?.code === 'VALIDE' && 'Commencer'}
                    {loadingCommencer && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Commencer{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                )}
                {data[0]?.statut?.code === 'EN COURS' && (
                  <button
                    type='button'
                    className='btn btn-danger me-2'
                    onClick={showRefusDemontageModal}
                    disabled={data[0]?.statut?.code === 'EN COURS' && checkedPieces.length === 0}
                  >
                    Refuser
                  </button>
                )}
                {data[0]?.statut?.code === 'EN COURS' && (
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={handleDemonterPiecesSubmit}
                    disabled={data[0]?.statut?.code === 'EN COURS' && checkedPieces.length === 0}
                  >
                    {!loadingDemonter && 'Démontée(s)'}
                    {loadingDemonter && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Chargement...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                )}
              </div>
            )}
          </div>

          {/*fenêtre de visualisation de commentaires*/}
          <ClientDemandeMessage demandeId={null} demontage={data[0]} />
        </>
      )}

      {openRefusDemontageModal && (
        <RefusDemontageRealisationModal
          show={openRefusDemontageModal}
          demandeDemontageId={demandeDemontageId}
          checkedPieces={checkedPieces}
          setCheckedPieces={setCheckedPieces}
          showModal={toggleShowRefusDemontageModal}
          data={data}
          setData={setData}
          vehiculeId={vehiculeId}
        />
      )}
    </>
  )
}
export {DemandeDemontageRealisation}
